export var QueryJoinType;
(function (QueryJoinType) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    QueryJoinType["OR"] = "OR";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    QueryJoinType["AND"] = "AND";
})(QueryJoinType || (QueryJoinType = {}));
//# sourceMappingURL=QueryJoinType.js.map